import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import CommentIcon from "@material-ui/icons/Comment";
import PositiveIcon from "@material-ui/icons/ThumbUp";
import { mdiCheckCircle, mdiLightbulb, mdiWrench } from "@mdi/js";
import Icon from "@mdi/react";
import moment from "moment-timezone";
import React from "react";
import { languages } from "../../constants/languages";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(3),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: theme.spacing(2),
    },
  },
  statusContainer: {
    width: 56,
    height: 56,
    marginRight: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 16,
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease",
    "$root:hover &": {
      transform: "scale(1.05)",
    },
    [theme.breakpoints.down("xs")]: {
      marginRight: 0,
    },
  },
  contentContainer: {
    flex: 1,
    minWidth: 0,
    marginRight: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginRight: 0,
    },
  },
  ideaString: {
    fontSize: "0.875rem",
    lineHeight: 1.3,
    color: theme.palette.text.primary,
  },
  chips: {
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  icon: {
    fontSize: 32,
  },
}));

const FeaturesListElement = (props) => {
  const classes = useStyles();

  const getStatusStyle = () => {
    if (props.feature.done) {
      return {
        background: "linear-gradient(to bottom, #66BB6A, #66BB6A60)",
        icon: <Icon color="white" path={mdiCheckCircle} size={1} />,
      };
    }
    if (props.feature.underDev) {
      return {
        background: "linear-gradient(to bottom, #FFA726, #FFA72660)",
        icon: <Icon color="white" path={mdiWrench} size={1} />,
      };
    }
    return {
      background: "linear-gradient(to bottom, #42A5F5, #42A5F560)",
      icon: <Icon color="white" path={mdiLightbulb} size={1} />,
    };
  };

  const statusStyle = getStatusStyle();

  return (
    <Paper
      className={classes.root}
      onClick={(e) => {
        props.handleFeatureClick(e, props.feature[".key"]);
      }}
    >
      <div
        className={classes.statusContainer}
        style={{ background: statusStyle.background }}
      >
        {statusStyle.icon}
      </div>

      <div className={classes.contentContainer}>
        <div className={classes.ideaString}>{props.feature.ideaString}</div>

        <div className={classes.chips}>
          <Chip
            size="small"
            style={{
              backgroundColor: "#EDEFF1",
              height: 28,
              fontWeight: 500,
              borderRadius: 5,
              fontSize: "0.875rem",
            }}
            label={moment
              .unix(props.feature.date)
              .format(languages.features.dateFormat)}
          />

          <Chip
            size="small"
            style={{
              backgroundColor: "#EDEFF1",
              height: 28,
              fontWeight: 500,
              borderRadius: 5,
              fontSize: "0.875rem",
            }}
            label={languages.features.categories[props.feature.category]}
          />
          {props.numVotes > 0 && (
            <Chip
              size="small"
              style={{
                backgroundColor: "#EDEFF1",
                height: 28,
                fontWeight: 500,
                borderRadius: 5,
                fontSize: "0.875rem",
              }}
              label={props.numVotes}
              icon={<PositiveIcon style={{ fontSize: 16 }} />}
            />
          )}
          {props.numMessages > 0 && (
            <Chip
              size="small"
              style={{
                backgroundColor: "#EDEFF1",
                height: 28,
                fontWeight: 500,
                borderRadius: 5,
                fontSize: "0.875rem",
              }}
              label={props.numMessages}
              icon={<CommentIcon style={{ fontSize: 16 }} />}
            />
          )}
        </div>
      </div>
    </Paper>
  );
};

export default FeaturesListElement;
